export const isLocal = false

console.log(process.env.ENVIRONMENT)

export const isDev = process.env.NODE_ENV === "development"